export default __webpack_public_path__ + "static/media/poi_hospital.d9d0c58e.svg";